// removed by extract-text-webpack-plugin
module.exports = {"pdpHeartItem":"RelatedFavoriteItem-style__pdpHeartItem__db41e3d9"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Favorites/RelatedFavoriteItem-style.scss
// module id = 3505
// module chunks = 4